import type { ParamType } from '@/api/types.ts'
import WorkflowTemplateApi from '@/api/WorkflowTemplate'
import type { WorkflowTemplateFetchParams } from '@/api/WorkflowTemplate/types.ts'
import { queryOptions, useQuery } from '@tanstack/react-query'

export function useFetchWorkflowTemplates(
  initiativeId: ParamType,
  params: WorkflowTemplateFetchParams
) {
  return useQuery({
    queryKey: ['fetch-workflow-templates', initiativeId, params],
    queryFn: () => WorkflowTemplateApi.fetch([initiativeId], params),
  })
}

export function getWorkflowTemplateQueryOptions(
  initiativeId: ParamType,
  templateId: ParamType
) {
  return queryOptions({
    queryKey: ['get-workflow-template', initiativeId, templateId],
    queryFn: () => WorkflowTemplateApi.get([initiativeId, templateId]),
  })
}

export function useGetWorkflowTemplate(
  initiativeId: ParamType,
  templateId: ParamType
) {
  return useQuery(getWorkflowTemplateQueryOptions(initiativeId, templateId))
}
